import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export function useProducts() {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data, error } = await supabase
          .from("ray_melo_products")
          .select("*")
          .eq("visible", true)
          .order("created_at", { ascending: false });

        if (error) throw error;

        setProducts(data || []);
      } catch (err) {
        console.error("Erro ao buscar produtos:", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return { products, loading };
}